/**
 * Get the base URL for the application based on environment
 * In browser, use relative paths for better performance
 * On server, use environment variable or fallback to production URL
 */
export function getBaseUrl() {
  if (typeof window !== "undefined") return ""; // In browser, use relative paths
  return process.env.NEXT_PUBLIC_SITE_URL ?? "https://www.indiestryvoice.com";
}

/**
 * Get the full URL for a given path
 * @param path - The path to append to the base URL
 * @returns The full URL
 */
export function getFullUrl(path: string = "") {
  const baseUrl = getBaseUrl();
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
}

/**
 * Get the site URL for OAuth redirects and external callbacks
 * This should always return the full URL, even in browser
 */
export function getSiteUrl() {
  // In browser, use the current origin
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  // On server, use environment variable or fallback to production URL
  return process.env.NEXT_PUBLIC_SITE_URL ?? "https://www.indiestryvoice.com";
} 